import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Stack,
} from "@mui/material";
import ActionTable from "../../components/table/ActionTable";
import { formatDateTime } from "../../helpers/helpers";
import "./Fatura.css";

// import ChecklistIcon from "@mui/icons-material/Checklist";
import StarterKit from "@tiptap/starter-kit";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  RichTextEditor,
} from "mui-tiptap";
import { useRef } from "react";
import { Height } from "@mui/icons-material";
// import { RichTextEditor } from "mui-tiptap";

export default function FaturaEscola(props) {
  const rteRef = useRef(null);

  const [parametros] = useState({
    escolaId: props.match.params.escolaId,
    ano: props.match.params.ano,
    mes: props.match.params.mes,
  });

  const { notification } = useContext(AppContext);
  const { intitular } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [gerandoFatura, setGerandoFatura] = useState(false);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [faturasGeradas, setFaturasGeradas] = useState([]);
  const [extrato, setExtrato] = useState({});
  const [faturaSelecionada, setFaturaSelecionada] = useState({});
  const [registroPagamentoAvulso, setRegistroPagamentoAvulso] = useState({});
  const [dataAtual] = useState(new Date());
  // const history = useHistory();
  const history = props.history;
  const [lista, setLista] = useState([]);
  const [inserir, setInserir] = useState(false);
  const [listaEmails, setListaEmails] = useState([]);
  const [checkedIds, setCheckedIds] = useState([]);
  const [dadosEmail, setDadosEmail] = useState({ titulo: "", mensagem: "" });

  const [filtros, setFiltros] = useState({
    escolaId: props.match.params.escolaId ? props.match.params.escolaId : 0,
    mes: props.match.params.mes
      ? props.match.params.mes
      : new Date().getMonth() + 1,
    ano: props.match.params.ano
      ? props.match.params.ano
      : new Date().getFullYear(),
  });

  useEffect(() => {
    intitular("Extrato da Escola");
    if (parametros.escolaId && parametros.ano && parametros.mes) {
      carregarExtrato(filtros);
    }

    carregarComboEscolas();
    carregarEmails();
  }, []);

  const carregarEmails = () => {
    api
      .get("escolas/listarEmails", { escolaId: props.match.params.escolaId })
      .then((res) => {
        setListaEmails(res);
        const atualizarLista = [];
        res.forEach((item) => atualizarLista.push(item.escolaEmailId));
        setCheckedIds(atualizarLista);
      })
      .catch((err) => notification("error", "Erro ao listar as emails"));
  };

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas))
      .catch((err) => notification("error", "Erro ao listar as escolas"));
  };

  const carregarExtrato = (params) => {
    setCarregando(true);

    let dadosExtrato = {
      mes: Number(params.mes),
      ano: Number(params.ano),
      escolaId: Number(params.escolaId),
      // usuarioId: props.user.id,
    };

    api
      .get("faturas/extratoEscola", dadosExtrato)
      .then((extrato) => {
        extrato.itens.forEach((item) => {
          item.descricao = `Pedido nº ${item.pedidoId} (parcela ${item.pedidoPagamentoParcelaNumero}/${item.pedidoNumeroParcelas})`;
          item.valor = `R$ ${(item.pedidoPagamentoValor / 100).toFixed(2)}`;
        });

        setExtrato(extrato);
        setFiltros(params);
        setCarregando(false);

        listarFaturasGeradas(extrato);
        carregar(dadosExtrato);
      })
      .catch((e) => notification("error", "Erro ao carregar o extrato"));
  };

  const listarFaturasGeradas = (extrato) => {
    const dadosExtrato = {
      mes: extrato.mes,
      ano: extrato.ano,
      escolaId: extrato.escolaId,
    };

    api
      .get("faturas/listar", dadosExtrato)
      .then((faturasGeradas) => {
        faturasGeradas.forEach((f) => {
          f.geracao = formatDateTime(f.geracao, "D/M/Y h:m");
          f.vencimento = formatDateTime(f.vencimento, "D/M/Y");

          if (f.pagamento) {
            f.situacao = f.pagamentoExterno
              ? "Pagamento registrado (externo)"
              : "Pagamento registrado";
          } else {
            f.situacao = f.cancelamento
              ? `Cancelada (${formatDateTime(f.cancelamento, "D/M/Y h:m")})`
              : `Pagamento não registrado`;
          }

          if (!f.iuguId) {
            f.avulsa = true;
            f.iuguId = "(fatura avulsa)";
          }

          f.iuguUrl = f.iuguUrl ? (
            <a href={f.iuguUrl} target="_blank" rel="noreferrer">
              {f.iuguUrl}
            </a>
          ) : (
            "(fatura avulsa)"
          );
        });

        setFaturasGeradas(faturasGeradas);
      })
      .catch((e) => {
        notification("error", "Erro ao listar as faturas geradas");
        console.log(e);
      });
  };

  const carregar = (filtrosEnviar = filtros) => {
    const dadosEnviar = {
      faturaVencimentoAno: Number(filtrosEnviar.ano),
      faturaVencimentoMes: Number(filtrosEnviar.mes),
      escolaId: props.match.params.escolaId,
    };

    api
      .get("faturas/listarEnviosEmails", dadosEnviar)
      .then((res) => {
        res.forEach((r) => {
          r.fatura = (
            <p>
              {r.faturaVencimentoMes}/{r.faturaVencimentoAno}
            </p>
          );
          r.sucesso = !r.faturaEnvioEmailErro ? "Sim" : "Não";
          r.faturaEnvio = formatDateTime(r.faturaEnvioEmailEnvio, "D/M/Y h:m");
        });
        setLista(res);
      })
      .catch((e) => {
        console.log("erro envios", e);
      });
  };

  const fFiltros = {
    title: "Pedido",
    form: {
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: filtros.escolaId,
      },
      mes: {
        label: "Mês",
        type: "select",
        emptyItem: true,
        space: 3,
        array: {
          data: meses,
          value: "id",
          desc: "nome",
        },
        value: filtros.mes,
      },
      ano: {
        label: "Ano",
        type: "select",
        value: filtros.ano,
        space: 3,
        options: (() => {
          const anos = [];

          for (
            var i = dataAtual.getFullYear() - 3;
            i <= dataAtual.getFullYear();
            i++
          ) {
            anos.push({ value: i, desc: i.toString() });
          }

          return anos;
        })(),
      },
    },
    submit: {
      label: "carregar",
      action: carregarExtrato,
    },

    history,
    close: true,

    // urlParams: true,
    // history: history,
    // location: location,
  };

  const selecionarFatura = (faturaSelecionada) => {
    setFaturaSelecionada(faturaSelecionada);
  };

  const tFaturasGeradas = {
    title: "Faturas geradas",
    array: faturasGeradas,
    columns: [
      {
        name: "geracao",
        label: "Gerada em",
      },
      {
        name: "vencimento",
        label: "Vencimento",
      },
      {
        name: "iuguId",
        label: "ID Iugu",
      },
      {
        name: "iuguUrl",
        label: "URL Iugu",
      },
      {
        name: "situacao",
        label: "Situação",
      },
    ],
    actions: [
      {
        title: "Detalhar",
        action: selecionarFatura,
        icon: "zmdi zmdi-zoom-in",
      },
    ],
  };

  const tbItens = {
    title: "Itens",
    array: extrato.itens,
    columns: [
      {
        name: "descricao",
        label: "Descrição",
      },
      {
        name: "valor",
        label: "Valor",
      },
    ],
  };

  const camposDadosExtrato = () => {
    const campos = {
      total: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Total</h4>
            <p>{`R$ ${(extrato.valorTotalItens / 100).toFixed(2)}`}</p>
          </div>
        ),
      },
    };

    if (extrato.faturaEscolaId) {
      campos.idFatura = {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Fatura (Iugu)</h4>
            <a target="_blank" href={extrato.faturaIuguUrl} rel="noreferrer">
              {extrato.faturaIuguId}
            </a>
          </div>
        ),
      };
      campos.linkFatura = {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>URL da fatura</h4>
            <p>{extrato.faturaIuguUrl}</p>
          </div>
        ),
      };
    }

    return campos;
  };

  const faturar = () => {
    setGerandoFatura(true);
    const dadosFatura = {
      escolaId: extrato.escolaId,
      // usuarioId: this.props.user.id,
      mes: extrato.mes,
      ano: extrato.ano,
    };

    api
      .put("faturas/faturar", dadosFatura)
      .then((faturaGerada) => {
        setGerandoFatura(false);
        notification("success", "Fatura gerada com sucesso!");
        setFaturaSelecionada({});
        return carregarExtrato(filtros);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Período inválido");
          case 2:
            return notification("error", "Sem pagamentos para faturar");
          case 3:
            return notification("error", "Já existe fatura aberta para o período");
          case 4:
            return notification("error", "Erro ao gerar a fatura no serviço de pagamento. Verifique os dados cadastrais da escola e tente novamente.")
          default:
            return notification(
              "error",
              "Erro ao gerar a fatura. Verifique os dados cadastrais da escola e tente novamente."
            );
        }
      });
  };

  const gerarFaturaAvulsa = () => {
    setGerandoFatura(true);

    const dadosFatura = {
      escolaId: extrato.escolaId,
      mes: extrato.mes,
      ano: extrato.ano,
    };

    api
      .put("faturas/faturarAvulsa", dadosFatura)
      .then((faturaGerada) => {
        setGerandoFatura(false);
        notification("success", "Fatura gerada com sucesso!");
        setFaturaSelecionada({});
        return carregarExtrato(filtros);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Período inválido");
          case 2:
            return notification("error", "Sem pagamentos para faturar");
          default:
            return notification(
              "error",
              "Já existe fatura ativa para o período"
            );
        }
      });
  };

  const fDadosExtrato = {
    form: camposDadosExtrato(),
    customActions: extrato.faturavel
      ? [
          {
            label: "Gerar fatura (Iugu)",
            action: faturar,
          },
          {
            label: "Gerar fatura avulsa",
            action: gerarFaturaAvulsa,
          },
        ]
      : undefined,
  };

  const registroPagamento = (faturaId) => {
    const dados = {
      faturaId: faturaId,
      observacao: "",
    };
    api
      .post("faturas/registrarPagamentoAvulsa", dados)
      .then(() => {
        notification("success", "Pagamento registrado para a fatura.");
        setFaturaSelecionada({});
        listarFaturasGeradas(extrato);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Fatura não avulsa");
          case 2:
            return notification("error", "Já paga");
          case 3:
            return notification("error", "Fatura cancelada");
          default:
            return notification("error", "Dados inconsistentes");
        }
      });
  };

  const fPagamentoAvulso = {
    title: "Fatura avulsa - Registrar pagamento",
    form: {
      observacao: {
        label: "Observação",
        type: "textarea",
      },
    },

    submit: {
      label: "Registrar",
      // action: registroPagamentoAvulso,
    },
    close: {
      label: "Fechar",
      action: () => setRegistroPagamentoAvulso({}),
    },
  };

  const camposFaturaGerada = () => {
    const campos = {
      geradaEm: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Gerada em</h4>
            <p>{faturaSelecionada.geracao}</p>
          </div>
        ),
      },

      vencimento: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Vencimento</h4>
            <p>{faturaSelecionada.vencimento}</p>
          </div>
        ),
      },

      iuguId: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>ID Iugu</h4>
            <p>{faturaSelecionada.iuguId}</p>
          </div>
        ),
      },

      iuguUrl: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>URL Iugu</h4>
            <p>{faturaSelecionada.iuguUrl}</p>
          </div>
        ),
      },

      situacao: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Situação</h4>
            <p>{faturaSelecionada.situacao}</p>
          </div>
        ),
      },

      pagamentoObservacao: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Observação pagamento</h4>
            <p>{faturaSelecionada.pagamentoObservacao}</p>
          </div>
        ),
      },
    };

    return campos;
  };

  const fFaturaGerada = {
    form: camposFaturaGerada(faturaSelecionada),
    title: "Fatura gerada",

    close: {
      label: "Fechar",
      action: () => setFaturaSelecionada({}),
    },
    customActions: [],
  };

  const cancelarFatura = (fatura) => {
    if (fatura.cancelamento)
      return notification("warning", "Fatura já cancelada.");
    api
      .post("faturas/cancelar", { faturaId: fatura.faturaEscolaId })
      .then(() => {
        notification("warning", "Fatura cancelada.");
        setFaturaSelecionada({});
        listarFaturasGeradas(extrato);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return (
              notification("error", "Já cancelada"), setFaturaSelecionada({})
            );
          case 2:
            return (
              notification("error", "Fatura paga"), setFaturaSelecionada({})
            );
          default:
            return (
              notification("error", "Dados inválidos"), setFaturaSelecionada({})
            );
        }
      });
  };

  if (!faturaSelecionada.pagamento && !faturaSelecionada.cancelamento) {
    fFaturaGerada.customActions.push({
      label: "Cancelar fatura",
      action: () => cancelarFatura(faturaSelecionada),
    });

    if (faturaSelecionada.avulsa) {
      fFaturaGerada.customActions.push({
        label: "Registrar pagamento",
        action: () => registroPagamento(faturaSelecionada.id),
      });
    }
  }

  const tRegistros = {
    title: "Emails enviados",
    newItemAction: () => setInserir(true),
    onLineClick: (item) =>
      window.open(
        `${window.location.origin}/app/financeiro-envios-emails/${item.faturaEnvioEmailId}`,
        "_blank"
      ),

    columns: [
      {
        label: "Enviado em",
        name: "faturaEnvio",
      },
      {
        label: "Fatura",
        name: "fatura",
      },
      {
        label: "Título",
        name: "faturaEnvioEmailTitulo",
      },
      {
        label: "Destinário",
        name: "faturaEnvioEmailDestinatario",
      },
      {
        label: "Enviado com sucesso",
        name: "sucesso",
      },
    ],
    array: lista,
  };

  const handleCheck = (id) => {
    setCheckedIds((prevCheckedIds) => {
      if (prevCheckedIds.includes(id)) {
        // Se o ID já estiver no array, removê-lo
        return prevCheckedIds.filter((checkedId) => checkedId !== id);
      } else {
        // Se o ID não estiver, adicioná-lo
        return [...prevCheckedIds, id];
      }
    });
  };

  const enviarEmailLembrete = () => {
    const dadosEnviar = {
      faturaVencimentoAno: Number(filtros.ano),
      faturaVencimentoMes: Number(filtros.mes),
      escolaEmailsIds: checkedIds,
      titulo: dadosEmail.titulo,
      mensagem: dadosEmail.mensagem,
      escolaId: props.match.params.escolaId,
    };

    if (!checkedIds.length)
      return notification(
        "warning",
        "Ao menos um email deve ser selecionado para envio"
      );
    api
      .post("faturas/enviarEmailLembrete", dadosEnviar)
      .then(() => {
        notification("success", "Lembrete enviado.");
        setInserir(false);
        setDadosEmail({ titulo: "", mensagem: "" });
        carregar();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification(
              "error",
              "Período inválido ou sem fatura em aberto"
            );
          case 2:
            return notification(
              "error",
              "Emails inválidos ou não pertencentes à escola"
            );
          case 3:
            return notification("error", "Título inválido");
          case 4:
            return notification("error", "Mensagem inválida");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const salvarDadosEmail = (campo, valor) => {
    const dadosEmailAtual = { ...dadosEmail };
    dadosEmailAtual[campo] = valor;

    setDadosEmail(dadosEmailAtual);
  };

  const handleEditorChange = () => {
    const htmlContent = rteRef.current?.editor?.getHTML();

    const dadosEmailAtual = { ...dadosEmail };
    dadosEmailAtual["mensagem"] = htmlContent;

    setDadosEmail(dadosEmailAtual);
  };

  const fEmail = {
    title: "Envio de email",
    form: {
      componente: {
        type: "component",
        value: (
          <div>
            <h4>Enviar para</h4>
            <FormGroup>
              {listaEmails.map((item) => (
                <FormControlLabel
                  key={item.escolaEmailId}
                  control={
                    <Checkbox
                      checked={checkedIds.includes(item.escolaEmailId)}
                      onChange={() => handleCheck(item.escolaEmailId)}
                    />
                  }
                  label={item.email}
                />
              ))}
            </FormGroup>
          </div>
        ),
      },
      titulo: {
        label: "Título",
        type: "text",
        space: 12,
        value: dadosEmail.titulo,
      },
      mensagem: {
        type: "component",
        space: 12,
        value: (
          <div>
            <h4>Mensagem</h4>
            <RichTextEditor
              ref={rteRef}
              extensions={[StarterKit]} // Or any Tiptap extensions you wish!
              content="" // Initial content for the editor
              onUpdate={handleEditorChange} // Lida com as mudanças automaticamente
              style={{
                height: "500px", // Altura fixa do editor
                minHeight: "500px", // Altura mínima
                padding: "10px", // Espaçamento interno
                border: "1px solid #ccc", // Borda ao redor do editor
                borderRadius: "8px", // Bordas arredondadas
                backgroundColor: "#f9f9f9", // Cor de fundo
                overflowY: "auto", // Rolagem vertical habilitada se necessário
              }}
              renderControls={() => (
                <MenuControlsContainer>
                  <MenuSelectHeading />
                  <MenuDivider />
                  <MenuButtonBold />
                  <MenuButtonItalic />
                </MenuControlsContainer>
              )}
            />
            {/* <br />

            <Button
              style={{ color: "white" }}
              variant="contained"
              onClick={() => console.log(rteRef.current?.editor?.getHTML())}
            >
              Salvar mensagem
            </Button>
            <br /> */}
          </div>
        ),
      },

      componenteBotoes: {
        type: "component",
        value: (
          <Stack direction={"row"} spacing={2}>
            <Button
              onClick={enviarEmailLembrete}
              style={{ color: "white" }}
              variant="contained"
              color="primary"
            >
              Enviar
            </Button>
            <Button
              onClick={() => {
                setInserir(false);
                setDadosEmail({ titulo: "", mensagem: "" });
              }}
              variant="contained"
              color="secondary"
            >
              Cancelar
            </Button>
          </Stack>
        ),
      },
    },
    autoSave: salvarDadosEmail,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          {faturasGeradas.length > 0 && (
            <>
              {faturaSelecionada.id ? (
                registroPagamentoAvulso.faturaId ? (
                  <Form formData={fPagamentoAvulso} />
                ) : (
                  <Form formData={fFaturaGerada} />
                )
              ) : (
                <ActionTable structure={tFaturasGeradas} />
              )}
            </>
          )}
          <br />

          {extrato.itens && extrato.itens.length > 0 && (
            <>
              {gerandoFatura ? (
                <CircularProgress />
              ) : (
                <Form formData={fDadosExtrato} />
              )}
              <ActionTable structure={tbItens} />
            </>
          )}

          {!inserir && <ActionTable structure={tRegistros} />}
          {inserir && (
            <div>
              <Form formData={fEmail} />
            </div>
          )}
        </>
      )}
    </div>
  );
}

const meses = [
  { id: "1", nome: "Janeiro" },
  { id: "2", nome: "Fevereiro" },
  { id: "3", nome: "Março" },
  { id: "4", nome: "Abril" },
  { id: "5", nome: "Maio" },
  { id: "6", nome: "Junho" },
  { id: "7", nome: "Julho" },
  { id: "8", nome: "Agosto" },
  { id: "9", nome: "Setembro" },
  { id: "10", nome: "Outubro" },
  { id: "11", nome: "Novembro" },
  { id: "12", nome: "Dezembro" },
];
